import BaseAPI from '../base';

function getInvoices(cafe_id) {
  return BaseAPI.get(`/superbilling/invoices/list/${cafe_id}`);
}

function updateSettings(cafe_id, params) {
  return BaseAPI.post(`/superbilling/settings/${cafe_id}`, params);
}

function changePlan(params) {
  return BaseAPI.post(`/superbilling/plan`, params);
}

function disableAutoPayment(cafe_id) {
  return BaseAPI.post(`/superbilling/disable-auto-payment/${cafe_id}`);
}

export default {
  getInvoices,
  updateSettings,
  changePlan,
  disableAutoPayment,
};
